import { render } from "./Preloader.vue?vue&type=template&id=206ad254&scoped=true"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import "./Preloader.vue?vue&type=style&index=0&id=206ad254&scoped=true&lang=css"

import exportComponent from "/tmp/build_5ac5815b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206ad254"]])

export default __exports__